import { render } from "./ReturnApplicationExpired.vue?vue&type=template&id=4ff1de96&scoped=true"
import script from "./ReturnApplicationExpired.vue?vue&type=script&lang=js"
export * from "./ReturnApplicationExpired.vue?vue&type=script&lang=js"

import "./ReturnApplicationExpired.vue?vue&type=style&index=0&id=4ff1de96&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff1de96"]])

export default __exports__